var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXpm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_33013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FFD81B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.75362C13.5 11.2416 11.5729 12.0876 9.95063 12.0876V12.7361H11.2022V13.6147H9.95119V14.625H7.99369V13.6147H6.79725V12.7361H7.99144V12.0791C7.47225 12.0791 4.5 11.9559 4.5 8.57306V4.5H6.44344V8.72887C6.44344 10.4946 7.99931 10.4783 7.99931 10.4783V4.5H9.95119V10.4783C9.95119 10.4783 11.5566 10.5683 11.5566 8.70469V4.5H13.5V8.75362Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_33013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpm);
export default __webpack_public_path__ + "static/media/xpm.00ba3750c1b0b62b5bffbdb790bbc405.svg";
export { ForwardRef as ReactComponent };